export function submitFormWithTurbo(formData, formPath, showLoadingState) {
  if (showLoadingState) {
    showLoadingState('Submitting data...');
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = formPath;
  form.enctype = 'multipart/form-data';
  form.setAttribute('data-turbo', 'true');

  for (const [key, value] of formData.entries()) {
    if (value instanceof File) {
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.name = key;
      fileInput.style.display = 'none';

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(value);
      fileInput.files = dataTransfer.files;
      form.appendChild(fileInput);
    } else {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  if (csrfToken && !formData.has('authenticity_token')) {
    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = 'authenticity_token';
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}

export function prepareFormData(selectedFile, rows, getMappedColumns, options) {
  const formData = new FormData();

  formData.append('generic_file_import[file]', selectedFile);

  const urlParams = new URLSearchParams(window.location.search);
  const importType = urlParams.get('import_type');
  const importableType = urlParams.get('importable_type');
  const importableId = urlParams.get('importable_id');

  if (importType) formData.append('generic_file_import[import_type]', importType);
  if (importableType) formData.append('generic_file_import[importable_type]', importableType);
  if (importableId) formData.append('generic_file_import[importable_id]', importableId);

  const mappings = getMappedColumns(rows[0]);
  mappings.forEach(({ sourceHeader, destinationHeader }) => {
    formData.append(`generic_file_import[columns_mapping][${destinationHeader}]`, sourceHeader);
  });

  options.forEach((option) => {
    const value = document.querySelector(`#${option.id}`).checked;
    formData.append(`generic_file_import[options][${option.id}]`, value);
  });

  return formData;
}
